import { JsonObject } from "json2typescript";

@JsonObject('RiskProfileModel')
export class RiskProfileModel {
  AssetClassDistribution?: AssetClassDistribution[];
  Id?: string;
  ModelPortfolioId?: string;
  ModelPortfolioName?: string;
  Name?: string;
  RiskProfileId?: string;
  RiskProfileName?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

export class AssetClassDistribution {
  Code?: string;
  Name?: string;
  Value?: number;
  Weight?: number;
}
